import DialogService from '~/services/DialogService';
import router from '~/router';
import URLS from '~/URLS';

export function mapVideos(videos, orgProfileId) {
    return videos.map(it => ({
        id: it.id,
        title: it.title,
        img:
            it.thumbnail ||
            'https://highered.global/wp-content/uploads/2020/01/default-company-banner.jpg',
        videoLink: it.videoLink,
        orgProfileId: orgProfileId,
    }));
}

export const mapLocations = locations =>
    locations.map(it => ({
        id: it.id,
        title: it.title,
        country: it.countryCode,
        img: it.logo || this.company.data.logo,
        click: () => router.push(URLS.findcompanies.concat('/', it.id)),
        /* DialogService.openLocalCompanyProfileDialog({
                id: it.id,
                parentId: it.parentCompanyId,
                title: it.title,
                img: it.logo || this.company.data.logo,
            }), */
    }));

export const mapArticles = articles =>
    articles.map(it => {
        return {
            title: it.title,
            img: it.featuredImage,
            click: () =>
                DialogService.openCompanyArticleDialog({
                    id: it.id,
                    title: it.title,
                    img: it.featuredImage,
                    slug: it.slug,
                }),
        };
    });
